import React from 'react';
import useDebounce from 'react-use/lib/useDebounce';
import {
  InputBase,
  InputBaseProps,
  InputAdornment,
  IconButton,
} from '@material-ui/core';
import SearchIcon from '@material-ui/icons/Search';
import ClearButton from '@material-ui/icons/Clear';
import { useEpDevPSearch } from '../../context';
import { useServiceRegistryTranslation } from '../../../../../i18n/ServiceRegistryLanguageProvider';

export type EpDevPSearchBarBaseProps = Omit<InputBaseProps, 'onChange' | 'onSubmit'>;
export type EpDevPSearchBarProps = Partial<EpDevPSearchBarBaseProps>;

export const EpDevPSearchBar = (props: EpDevPSearchBarProps) => {
  const { t } = useServiceRegistryTranslation();

  const { setSearchTerm } = useEpDevPSearch();

  const [value, setValue] = React.useState<string>('');
  const placeholder = props.placeholder ? props.placeholder : t('search.title');
  const debounceTime = 200;

  const onSubmit = React.useCallback((newValue: string) => {
    setSearchTerm(newValue);
  }, [setSearchTerm]);

  useDebounce(() => onSubmit(value), debounceTime, [value]);

  const handleChange = React.useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setValue(e.target.value);
  }, [setValue]);

  const handleKeyDown = React.useCallback((e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') onSubmit(value);
  }, [onSubmit, value]);

  const handleClear = React.useCallback(() => {
    setValue('');
  }, [setValue]);

  const startAdornment = (
    <InputAdornment position="start">
      <IconButton aria-label={t('developerSearch.query')} size="small" disabled>
        <SearchIcon />
      </IconButton>
    </InputAdornment>
  );

  const endAdornment = (
    <InputAdornment position="end">
      <IconButton aria-label={t('developerSearch.clear')} size="small" onClick={handleClear}>
        <ClearButton />
      </IconButton>
    </InputAdornment>
  );

  return (
    <InputBase
      data-testid="ep-devp-search-bar"
      // ref={ref}
      value={value}
      placeholder={placeholder}
      startAdornment={startAdornment}
      endAdornment={endAdornment}
      inputProps={{ 'aria-label': t('search.title') }}
      fullWidth
      onChange={handleChange}
      onKeyDown={handleKeyDown}
    />
  );
}
